import SampulDpnK13 from '../../../../views/Kurikulum/Raport/Cetak/SampulDpnK13.view.js';
import { connect } from 'react-redux';
import { getStudent } from '../../../../states/thunks/student.thunk';


function mapDispatchToProps(dispatch){ 
    return{
        handleGetStudent: () => dispatch(getStudent()),
    };
}
export default connect(null, mapDispatchToProps) (SampulDpnK13);
